import "antd/dist/antd.css";
import { Col, Divider, Input, Row, Image, Avatar, Menu, Dropdown, Form, Modal, Skeleton, Button, Card } from 'antd';
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../../actions/auth";
import { useCallback, useState } from "react";

import {
    EyeTwoTone, EyeInvisibleOutlined, MenuOutlined
} from "@ant-design/icons";
import swal from "sweetalert";
import { Route, useLocation, Switch, useHistory } from 'react-router-dom';
import { useEffect } from "react";
import axiosClient from "../../api/axios";

import SearchBar from "../SearchBar/searchBar";

const HeaderAdmin = () => {
    const history = useHistory();
    const Role = localStorage.getItem('Role');
    const [openModalPassword, setOpenModalPassword] = useState(false);
    const [visible, setVisible] = useState(false);
    // body 
    const IDLogin = localStorage.getItem("ID");
    const username = localStorage.getItem("UserName");
    //const fullname = localStorage.getItem("user");
    const password = localStorage.getItem("Password");
    const phone = localStorage.getItem("Phone");
    const email = localStorage.getItem("Email");
    const image = localStorage.getItem("Image");
    const active = localStorage.getItem("Active");
    const database = localStorage.getItem("DatabaseName");
    const securitycode = localStorage.getItem('SecurityCode');
    const expirationdate = localStorage.getItem('ExpirationDate');
    const role = String(localStorage.getItem('Role'));
    const codeCompany = localStorage.getItem('CompanyCode');
    // ----------------------------------------
    const title = localStorage.getItem('Title');
    const fullname = localStorage.getItem('FullName');
    const token = localStorage.getItem('token');

    const header = {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
    };
    const dispatch = useDispatch();
    const [openModal, setOpenModal] = useState(false);
    const [datalogo, setDataLogo] = useState([]);
    const [loading, setLoading] = useState(false);
    const [formPassword] = Form.useForm();

    const handleLogout = useCallback(() => {
        dispatch(logout());
        swal("Đăng xuất thành công", {
            buttons: false,
            icon: "success",
        });
        window.location.href = "/";
    }, [dispatch]);
    const showModalPassword = () => {
        setOpenModalPassword(true);
    }
    const cancelModalChangePassword = () => {
        setOpenModalPassword(false);
    }

    const [dataPermission, setDataPermission] = useState([]);
    const LoadDataPermission = () => {
        axiosClient.post('/Permissions/GetApiPermissionAll', '', { headers: header }).then(resPermiss => {
            setDataPermission(resPermiss.data);
        })
    }
    const dataMenu = [
        {
            label: 'Menu',
            value: '/adminpage/managermenu'
        },
        {
            label: 'Nội dung',
            value: '/adminpage/managercontent'
        },
    ]
    const menuMobile = (type) => {
        return (
            <div>
                <Menu style={type === 'mobile' ? null : centerStyle} mode={type === 'mobile' ? 'vertical' : 'horizontal'}>
                    <Menu.Item onClick={(e) => history.push('/adminpage/managercompany')} key="3" >
                        TỔ CHỨC
                    </Menu.Item>
                    <Menu.Item onClick={(e) => history.push('/adminpage/managermenu')} key="1" >
                        MENU
                    </Menu.Item>
                    <Menu.Item onClick={(e) => history.push('/adminpage/marquee')} key="marquee" >
                        BĂNG RÔN CHỮ
                    </Menu.Item>
                    <Menu.Item onClick={(e) => history.push('/adminpage/managerbanner')} key="2" >
                        BANNER
                    </Menu.Item>

                    <Menu.Item onClick={(e) => history.push('/adminpage/managercontent')} key="4" >
                        NỘI DUNG
                    </Menu.Item>
                    <Menu.Item onClick={(e) => history.push('/adminpage/members')} key="5" >
                        DANH BẠ LUẬT SƯ
                    </Menu.Item>
                    <Menu.Item style={{ position: 'absolute', right: 0 }} key="app" >
                        <Dropdown
                            overlay={menu}
                            trigger={["click"]}
                            placement="bottomLeft"
                        >
                            <div style={{ fontSize: 13 }} onClick={e => e.preventDefault()}>
                                Xin chào, <b>{fullname}</b>  <Avatar size="small" src={'https://i1.sndcdn.com/avatars-bUnqVculBgyraYkg-VTEr2Q-t500x500.jpg'} />
                            </div>
                        </Dropdown>
                    </Menu.Item>
                </Menu>
            </div>

        )
    }
    useEffect(() => {
        LoadDataPermission()
    }, [])



    const onChangePassword = (values) => {
        if (values.password1 !== values.password2) {
            swal('Mật mã mới và xác nhận mật mã không giống nhau', {
                icon: 'warning',
                buttons: false,
                timer: 2000
            });
        }
        else {
            axiosClient.post('/Accounts/ChangePassword', {
                "ID": IDLogin,
                "role": role,
                "UserName": username,
                "FullName": fullname,
                "Password": values.password1,
                "Phone": phone,
                "Email": email,
                "Image": image,
                "Active": true,
                "DatabaseName": database,
                "SecurityCode": securitycode,
                "ExpirationDate": expirationdate
            }, { headers: header }).then(res => {
                if (res.status === 200) {
                    swal('Thay đổi mật khẩu thành công', {
                        icon: 'success',
                        buttons: false,
                        timer: 2000
                    });
                    formPassword.resetFields();
                    setOpenModal(false);
                    setLoading(false);
                }
                else {
                    swal('Thay đổi mật khẩu không thành công', {
                        icon: 'error',
                        buttons: false,
                        timer: 2000
                    });
                    formPassword.resetFields();
                    setOpenModal(false);
                    setLoading(false);
                }
            });
        }
    }
    const renderChangePassword = () => {
        return (
            <Form
                id="form-modal"
                form={formPassword}
                onFinish={onChangePassword}
                name="basic"
                labelCol={{
                    span: 8,
                }}
                wrapperCol={{
                    span: 16,
                }}
                initialValues={{
                    remember: true,
                }}
                autoComplete="off"
            >
                <Form.Item name="password1" rules={[{ required: true, message: 'Vui lòng nhập mật khẩu' }]} label='Mật khẩu mới'>
                    <Input.Password iconRender={(visible) => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)} />
                </Form.Item>
                <Form.Item name={'password2'} rules={[{ required: true, message: 'Vui lòng xác nhận mật khẩu' }]} label='Xác nhận mật khẩu'>
                    <Input.Password iconRender={(visible) => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)} />
                </Form.Item>

            </Form>
        )
    }
    const { isLoggedIn } = useSelector((state) => state.auth);
    const menu = (
        <Menu >
            <Menu.Item disabled={isLoggedIn === true && role.toLocaleLowerCase() === 'admin' ? false : true} onClick={(e) => window.location.href = '/adminpage/manageraccount'} key="2">
                <h3 style={{ color: role.toLocaleLowerCase() === 'admin' ? null : '#C0C0C0' }}>Quản lý tài khoản</h3>
            </Menu.Item>
            <Menu.Item disabled={isLoggedIn === true && role.toLocaleLowerCase() === 'admin' ? false : true} onClick={(e) => window.location.href = '/adminpage/decentralization'} key="3">
                <h3 style={{ color: role.toLocaleLowerCase() === 'admin' ? null : '#C0C0C0' }}>Phân quyền</h3>
            </Menu.Item>
            <Menu.Item onClick={(e) => showModalPassword(e)} key="0">
                <h3>Thay đổi mật khẩu</h3>
            </Menu.Item>
            <Menu.Item onClick={(e) => handleLogout(e)} key="1">
                <h3>Đăng xuất</h3>
            </Menu.Item>
        </Menu>
    );
    const centerStyle = {
        position: 'relative',
        display: 'flex',
        justifyContent: 'center',
        backgroundColor: '#003399',
        color: 'white',
        fontWeight: 500,
        minWidth: 215,
        textShadow: "0px  0px  2px  black"
    };

    return (
        <div style={{ borderBottomColor: 'black', position: 'relative', textAlign: 'center', }}>
            <Row>
                <Col xs={0} xl={24} span={24}>

                    {menuMobile('desktop')}
                </Col>
                <Col style={{
                    backgroundColor: '#003399',
                    color: 'white',
                    height: 40,
                    paddingTop: 4
                }} xs={24} xl={0} span={24}>
                    <Row>
                        <Col style={{ textAlign: 'center', paddingLeft: 7 }} span={22}>
                            {SearchBar(dataMenu)}
                        </Col>
                        <Col style={{ paddingTop: 6 }} span={2}>
                            <Dropdown
                                overlayStyle={{ width: 200 }}
                                overlay={menuMobile('mobile')}
                                trigger={["click"]}
                                placement="bottomRight"
                            >
                                <div style={{ textAlign: 'center' }}>
                                    <MenuOutlined style={{ fontSize: 18 }} />
                                </div>
                            </Dropdown>
                        </Col>
                    </Row>

                </Col>
            </Row>
            <Modal
                width={600}
                visible={visible}
                open={openModalPassword}
                title={
                    <span>
                        Thay đổi mật khẩu
                    </span>
                }
                onCancel={cancelModalChangePassword}
                footer={[
                    <Button key="back" onClick={cancelModalChangePassword}>
                        Hủy
                    </Button>,
                    <Button form="form-modal" type="primary" htmlType="submit" loading={loading}>
                        Lưu
                    </Button>,
                ]}
            >
                {loading ? (
                    <>
                        <Skeleton loading={loading} active />
                    </>
                ) : (
                    <>{renderChangePassword()}</>
                )}
            </Modal>

        </div>
    )
}
export default HeaderAdmin